export const ADD_QUEUE = 'TOASTER_QUEUE_ADD_QUEUE'
export const SET_QUEUE = 'TOASTER_QUEUE_SET_QUEUE'
export const SET_BUTTON_ENABLED = 'TOASTER_QUEUE_SET_BUTTON_ENABLED'
export const SET_VISIBILITY = 'TOASTER_QUEUE_SET_VISIBILITY'
export const BUTTON_CLICKED = 'TOASTER_QUEUE_BUTTON_CLICKED'



// WEBPACK FOOTER //
// ./src/features/Toaster/data/queue/constants.js